import { toMinorUnits } from '@/api/map/create'

export interface CreditTransferRequest {
  direction: 'give' | 'take'
  amount: string
}

/** OpenAPI CreditTransferRequest — amount in minor units. */
export function toCreditTransferRequest(input: {
  direction: 'give' | 'take'
  amount: number
}): CreditTransferRequest {
  return {
    direction: input.direction,
    amount: toMinorUnits(input.amount),
  }
}
